/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

import { connect } from 'react-redux';

import {
  setContainerClassnames,
  clickOnMobileMenu,
} from '../../redux/actions';

import { getSession, signOut } from '../../services/auth';
import { clearAuthCache } from '../../helpers/authHelper';

import TopnavNotifications from './Topnav.Notifications';
import PersonSelector from './PersonSelector';
import TopnavMessageQueue from './Topnav.MessageQueue';
import TopnavIdentity from './Topnav.Identity';

const TopNav = ({
  containerClassnames,
  menuClickCount,
  selectedMenuHasSubItems,
  setContainerClassnamesAction,
  clickOnMobileMenuAction,
  mobileNavOpen = false,
  onMobileMenuToggle,
}) => {
  const navigate = useNavigate();
  const [isInFullScreen, setIsInFullScreen] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  // Platform-appropriate shortcut hint (⌘ on Mac, Ctrl elsewhere).
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');

  // Fetch user session on mount
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const session = await getSession();
        if (session?.email) {
          setUserEmail(session.email);
        }
      } catch (error) {
        console.error('Failed to get user session:', error);
      }
    };
    fetchUser();
  }, []);

  const isInFullScreenFn = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  const toggleFullScreen = () => {
    const isFS = isInFullScreenFn();

    const docElm = document.documentElement;
    if (!isFS) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsInFullScreen(!isFS);
  };

  const handleLogout = async () => {
    try {
      await signOut();
      clearAuthCache();
      navigate('/user/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Still redirect even if there's an error
      clearAuthCache();
      navigate('/user/login');
    }
  };

  return (
    <nav className="navbar fixed-top">
      {/* Mobile hamburger menu */}
      <button
        className="mobile-menu-btn"
        type="button"
        aria-label="Toggle navigation menu"
        aria-expanded={mobileNavOpen}
        aria-controls="compact-sidebar"
        onClick={() => onMobileMenuToggle?.()}
        data-tooltip="Toggle navigation"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Left section - global search entry point. Opens the command palette
          (the app's real search) via a window event AppLayout listens for, so
          the palette is discoverable instead of being a hidden Cmd+K secret. */}
      <div className="navbar-left">
        <button
          type="button"
          className="navbar-search-trigger"
          onClick={() => window.dispatchEvent(new CustomEvent('inquisitor:open-command-palette'))}
          aria-label="Search views and actions"
          aria-keyshortcuts="Meta+K Control+K"
        >
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15" aria-hidden="true">
            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
          </svg>
          <span className="navbar-search-text">Search…</span>
          <kbd className="navbar-search-kbd">{isMac ? '⌘K' : 'Ctrl K'}</kbd>
        </button>
      </div>


      {/* Center section - Connection Sockets */}
      <div className="navbar-center">
        <PersonSelector />
      </div>

      {/* Right section - Notifications & User */}
      <div className="navbar-right">
        <div className="header-icons">
          <TopnavMessageQueue />
          <button
            className="header-icon"
            type="button"
            aria-label="Open action history"
            onClick={() => window.dispatchEvent(new CustomEvent('inquisitor:open-audit-log'))}
            data-tooltip="Action history"
          >
            <i className="simple-icon-list" />
          </button>
          <TopnavNotifications />
          <TopnavIdentity />
          <button
            className="header-icon"
            type="button"
            aria-label={isInFullScreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            onClick={toggleFullScreen}
            data-tooltip={isInFullScreen ? 'Exit fullscreen' : 'Enter fullscreen'}
          >
            <i className={isInFullScreen ? 'simple-icon-size-actual' : 'simple-icon-size-fullscreen'} />
          </button>
        </div>
        <div className="user">
          <UncontrolledDropdown className="dropdown-menu-right">
            <DropdownToggle color="empty">
              <span className="name">{userEmail || 'User'}</span>
              <span className="user-avatar">
                {userEmail ? userEmail.charAt(0).toUpperCase() : 'U'}
              </span>
              <i className="simple-icon-arrow-down dropdown-chevron" />
            </DropdownToggle>
            <DropdownMenu className="mt-3" end>
              <DropdownItem header className="user-email-header">
                {userEmail}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => handleLogout()}>
                Sign out
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnamesAction: setContainerClassnames,
  clickOnMobileMenuAction: clickOnMobileMenu,
})(TopNav);
